import { DesignLanguage, Text, useIsDesignLanguage } from '@afterpaytouch/core'
import { useFlag } from '@afterpaytouch/feature'
import { Country } from '@afterpaytouch/portal-api/types'
import React, { FunctionComponent, useEffect, useState } from 'react'
import { markUsFebConsentCopyDisplayed } from '../../flow/one-offer-page/consentCopySignal'
import { Features } from '../../model'
import { useCountry } from '../../state'
import { Trans, useTranslation } from '../../utils/convergence'
import { TermLink } from '../TermLink'

export const useUsFebConsentCopy = (): boolean => {
  const isEvergreenConsentEnabled = useFlag<boolean>(Features.ENABLE_CHECKOUT_EVERGREEN_CONSENT, false)
  const country = useCountry()
  const [showUsFebConsent] = useState(() => isEvergreenConsentEnabled && country === Country.US)

  useEffect(() => {
    if (showUsFebConsent) {
      markUsFebConsentCopyDisplayed()
    }
  }, [showUsFebConsent])

  return showUsFebConsent
}

export const UsFebConsentCopy: FunctionComponent = () => {
  const { t } = useTranslation()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)

  return (
    <Text color='Gray40' size='XXS' fontFace='CashSansMono' testNameSpace='one-offer-page-consent'>
      <Trans
        i18nKey='login:oneOfferPageConsent'
        components={{
          feb: (
            <TermLink
              key='feb-privacy-policy'
              href={t('consumerLending:febPrivacyPolicyUrl')}
              color={isArcadeDesignLanguage ? 'Black' : 'Orca'}
              fontFace='CashSansMono'
              testNameSpace='one-offer-page-feb-privacy-policy'
              target='_blank'
              inline
            />
          ),
        }}
      />
    </Text>
  )
}
